
/* eslint-disable complexity */
import React, { useEffect, useMemo, useState, useCallback, useLayoutEffect } from 'react';
import { queryTriples2, queryPath, queryInstanceDetails, autoComplete, queryStyle, relationRecommend,queryConcept } from '../../../shared/api';
import $ from 'jquery';
import echarts from 'echarts';
// "echarts": "^4.8.0",  16：28  1003
import cls from 'classnames';
// import { Link } from 'react-router-dom';
import './index.scss';
import { htmltoStr, GetQueryString } from '../../../../utils';
import Loading from '../../../components/Loading';
import { Picture } from '@portal-site/components';
import Default from '@/assets/images/desktop/common/default.jpg';
import * as d3 from 'd3';
import Star from '../../common/Star';
const pre = window.ENV_IMG_PREURL_SRC;

/**
    * 节点去重
    */
 function reduceNodes(nodes) {
  let arr = [];
  let obj = {};
  for (let i = 0; i < nodes.length; i++) {
      if (!obj[nodes[i].name]) {
          arr.push(nodes[i]);
          obj[nodes[i].name] = true;
      }
  }
  return arr;
}
/**
* 连线去重
*/
function reduceLinks(relation) {
  let arr = [];
  arr = relation.reduce(function (prev, element) {
      if (!prev.find(el => (el.source === element.source && el.target === element.target) || (el.source === element.target && el.target === element.source))) {
          prev.push(element)
      }
      return prev
  }, [])
  return arr;
}

const Relation = (props) => {
  let d3Canvas = {
    edges: null,  // 线元素组合的初始化
    links: null,  // 线初始化
    rects: null,  // 关系文字背景框初始化
    texts: null,  // 关系名称初始化
    circles: null,  // 实例节点圆形初始化
    circleTexts: null,  // 实例节点文字初始化
    relationRects: null,  // 关系节点矩形框初始化
    relationRectTexts: null,  // 关系节点文字初始化
  }
  const startsearch = GetQueryString('startsearch');
  const endsearch = GetQueryString('endsearch');
  const centersearch = GetQueryString('centersearch');
  const [id, setId] = useState();
  const isSearch = props.id ? false : true;   // isSearch:true,关系检索;false,仅图谱展示；
  const [temp, setTemp] = useState();
  const [name, setName] = useState();
  const [tab, setTab] = useState((endsearch && startsearch) ? 2 : 1);
  const [val1, setVal1] = useState(startsearch || '');
  const [val2, setVal2] = useState(endsearch || '');
  const [list, setList] = useState();
  const [title, setTitle] = useState();
  const [desc, setDesc] = useState();
  const [dshow, setDshow] = useState();
  const [autolist, setAutolist] = useState();
  const [autolist1, setAutolist1] = useState();
  const [autolist2, setAutolist2] = useState();
  const [showauto, setShowauto] = useState(false);
  const [showauto1, setShowauto1] = useState(false);
  const [showauto2, setShowauto2] = useState(false);
  const [loading, setLoading] = useState(true);
  const [opacity,setOpacity] = useState(0);
  const [showdata, setShowData] = useState();
  const [searchfold, setSearchfold] = useState(false);
  const [focus, setFocus] = useState(1); // 关系路径检索的时候停留的文本框 1起始搜索 2终点搜索 初始为起始
  const [isSame, setIsSame] = useState(false);
  const [renderData, setRenderData] = useState();
  const [conceptConfig, setConceptConfig] = useState();
  const [isCenter, setIsCenter] = useState();   // 当前是否展示的是中心节点关系图谱
  const centerRadius = 54;  // 中心节点半径
  const normalRadius = 36;  // 普通节点半径
  const pre = window.ENV_IMG_PREURL_SRC;
  const [startNode,setStartNode] = useState();
  const [endNode,setEndNode] = useState();
  const [startNodeId,setStartNodeId] = useState();
  // 赋值给 useEffect 的函数会在组件渲染到屏幕之后执行
  useEffect(() => {
    if(val1 === val2) {
      setIsSame(true)
    } else {
      setIsSame(false)
    }
  }, [val1, val2])

  useEffect(() => {
    // 判断是否为手机端访问
    let info = navigator.userAgent;
    let isPhone = /mobile/i.test(info);
    if(isPhone){
      if(centersearch){
        window.location.href= 'https://bwgiim.ahm.cn:8112/relation.html?centersearch='+centersearch;
      }else if(startsearch && endsearch){
        window.location.href= 'https://bwgiim.ahm.cn:8112/relation.html?startsearch='+startsearch+'&endsearch='+endsearch;
      }
    }

    if(props.match && props.match.params.id){
      setId(props.match.params.id);
    }
    if(props.id){
      setId(props.id);
    }
    // 获取热点推荐数据
    relationRecommend().then(res=>{
      let datas = res.data?.datas;
      datas.forEach(el => {
        el['show'] = el['datas'].slice(0,4);
        el['start'] = 0;
      })
      setShowData(datas);
    })
    // 力导向图画布初始化
    setTimeout(()=>{
      initMap();
    },0)
  }, [])

  const params = useMemo(() => {
    if(name || centersearch) {
      !name && setName(centersearch);
      return {
        // depth:3,
        current: 1,
        // size: 99,
        conceptCodes: [],
        nodeName: name || centersearch,
        relationshipType: 'Concept'
      }
    } else if(!name && id) {
      return {
        current: 1,
        // size: 99,
        conceptCodes: [],
        nodeId: id,
        relationshipType: 'Concept'
      }
    }
  }, [centersearch, id, name])

  // 渲染关系图
  const renderRelationDraw = useCallback((data, config, activeArr) => {
    // 中心节点检索
    if(tab === 1){
      let conceptArr = [];
      // 获取每个节点的一级概念id
      data.nodes.forEach(d => {
        if(d.labels.indexOf('Relation') == -1){
          // 根据当前概念id,获取一级父级概念id
          const rootConcept = getRootConceptId(d.properties.conceptId,config);
          d['rootConceptId'] = rootConcept.conceptId;
          const item1 = conceptArr.filter(i => {
            return i?.conceptName === rootConcept.conceptName;
          });
          if(item1.length === 0){
            conceptArr.push(rootConcept);
          }
        }
      });
      setConceptConfig(conceptArr);
      $('.legend ul li').addClass('active');
      let nodes = data.nodes.map(d => Object.create(d));
      // 给力导向图中的线段指定source、target属性
      data.relationships.forEach(d => {
        d['source'] = d['startNodeId'];
        d['target'] = d['endNodeId'];
      });
      let links = data.relationships.map(d => Object.create(d));
      let graphData = {
        'nodes': nodes,
        'links': links,
      }
      // 存储图谱数据
      setRenderData(graphData);
      // 清除力导向图
      emptyMapDatas();
      // 重新绘制力导向图
      showMap(nodes, links,true);
    }else{
      // 关系路径检索时不需要根据概念筛选
      setConceptConfig([]);
      // 过滤重复节点
      let nodes0 = []; 
      data.nodes.forEach(d => {
        if(nodes0.filter( el => el.properties.nodeId == d.properties.nodeId).length == 0){
          // 根据当前概念id,获取一级父级概念id
          const rootConcept = getRootConceptId(d.properties.conceptId,config);
          d['rootConceptId'] = rootConcept.conceptId;
          nodes0.push(d);
        }
      });
      // 过滤重复关系
      let links0 = [];
      data.relationships.forEach(d => {
          if(links0.filter( el => el.properties.uuid == d.properties.uuid).length == 0){
            d['source'] = d['startNodeId'];
            d['target'] = d['endNodeId'];
            links0.push(d);
          }
      });
      let nodes = nodes0.map(d => Object.create(d));
      let links = links0.map(d => Object.create(d));
      let graphData = {
        'nodes': nodes,
        'links': links,
      }
      // 存储图谱数据
      setRenderData(graphData);
      // 清除力导向图
      emptyMapDatas();
      // 重新绘制力导向图
      showMap(nodes, links,false);
    }
  }, [tab]);

  // 根据子级概念获取父级概念
  const getRootConceptId = (conceptId,allConcepts) => {
    let item = allConcepts.filter(el => el.conceptId == conceptId);
    if(item[0].parentId == 'root'){
      return item[0];
    }else{
      return getRootConceptId(item[0].parentId,allConcepts);
    }
  }

  const renderRelation = useCallback((data, activeArr) => {
    queryConcept('').then(res => {
      if(res) {
        // 获取所有一级节点
        const config = res;
        renderRelationDraw(data, config, activeArr);
      }
    })
  }, [renderRelationDraw])

  const linkSearch = useCallback((start, end) => {
    if((start && end) || (val1 && val2) || (endsearch && startsearch)) {
      const startNodeName = start || val1 || startsearch;
      const endNodeName = end || val2 || endsearch;
      closeDrop();
      setLoading(true);
      setOpacity(0);
      queryPath({
        current: 1,
        depth: 5,
        endNodeId: "",
        endNodeName: endNodeName,
        size: 100,
        startNodeId: "",
        startNodeName: startNodeName,
        relationshipType: "Concept"
      }).then(res => {
        setTimeout(() => {
          setLoading(false);
          setOpacity(1);
        },1500);
        if(res && res?.length > 0) {
          setList(res)
          setStartNode(startNodeName);
          setEndNode(endNodeName);
          setStartNodeId(res[0].nodes[0].properties.nodeId);
          setIsCenter(false);
          const arr = {
            nodes: [],
            relationships: []
          }
          res.forEach(item => {
            arr.nodes = arr.nodes.concat(item.nodes);
            arr.relationships = arr.relationships.concat(item.relationships);
          })
          renderRelation(arr)
        }else{
          emptyMapDatas();
          setList([])
        }
      })
    }
  }, [endsearch, renderRelation, startsearch, val1, val2]);

  useLayoutEffect(() => {
    setLoading(true);
    setOpacity(0);
    if(params) {
      // 中心节点检索
      queryTriples2(params).then(res => {
        setTimeout(() => {
          setLoading(false);
          setOpacity(1);
        },600);
        if(res && res.nodes.length>0) {
          setIsCenter(true);
          setShowauto(false);
          renderRelation(res)
        }else{
          emptyMapDatas();
        }
      })
    } else if ( endsearch && startsearch ) {
      // 关系路径检索
      linkSearch()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endsearch, name, params, startsearch])

  const divisionStr = (str) => {
    if(str.length > 6) {
      return str.slice(0, 6) + '...';
    }
    return str.slice(0, 6);
  }
  const handleKeyDown = useCallback(
    (e) => {
      if (e.charCode === 0 && e.keyCode === 13) {
        setName(temp)
      }
    },
    [temp]
  );
  // 回车键搜索
  const handleSearch = useCallback(
    (e) => {
      if (e.charCode === 0 && e.keyCode === 13) {
        linkSearch();
      }
    },
    [linkSearch]
  );
  const getAutolist = (val) => {
    setShowauto(true)
    autoComplete(val).then(res => {
      setAutolist(res)
    })
  }
  const getAutolist1 = (val) => {
    setShowauto1(true)
    autoComplete(val).then(res => {
      setAutolist1(res)
    })
  }
  const getAutolist2 = (val) => {
    setShowauto2(true)
    autoComplete(val).then(res => {
      setAutolist2(res)
    })
  }
  const closeDrop = () => {
    setShowauto(false);
    setShowauto1(false);
    setShowauto2(false);
  }

  const exchange = () => {
    const start = val1;
    const end = val2;
    setVal1(end);
    setVal2(start);
    $('.input2 .val1').val(end);
    $('.input2 .val2').val(start);
    linkSearch(end, start);
  }

  const handleChoose = (name) => {
    if(tab === 1) {
      setName(name);
      $('#centerNodeName').val(name);
    } else if(tab === 2) {
      if(focus === 1) {
        setVal1(name);
        $(`.input2 .val1`).val(name);
        if(val2) {
          if(val2 === name) {
            setIsSame(true)
          } else {
            linkSearch(name, val2);
          }
        }
      }
      if (focus === 2) {
        setVal2(name);
        $(`.input2 .val2`).val(name);
        if(val1) {
          if(val1 === name) {
            setIsSame(true)
          } else {
            linkSearch(val1, name);
          }
        }
      }
    }
  }

  // 初始化图谱信息
  const initMap = () => {
    // 图谱放大缩小
    d3.select("#knowledgeGraph")
    .call(d3.zoom().scaleExtent([1 / 2, 4]).on("zoom", zoomed))
    .on('dblclick.zoom',null);    // 取消双击放大事件

    // 创建画布
    let svgBox = d3.select("#knowledgeGraph").append("svg")
                .attr("class", "svg")
                .append("g")
                .attr("class", "svgBox");  
    // 箭头和图像初始化
    svgBox.append("defs").attr("class", "arrows");
    svgBox.append("defs").attr("class", "avatars");
    // 其他元素初始化
    svgBox.append("g").attr("class", "relMap_g");
  }

  // 显示知识图谱方法
  const showMap = (nodes, links, isCenterSearch) => {
    // 获取搜索的节点名称
    let searchNames = [];
    let selectedNodeId = '';
    if(isCenterSearch){
      // 通过概念筛选节点时，需要重新绘制图谱，此时输入框的值可能发生了变化，因此此处应直接取第一个节点作为中心节点
      const node1 = nodes[0] ? nodes[0].properties.nodeName : '';
      searchNames = [node1];
    }else{
      const node1 = ($.trim($('#startNodeName').val()));
      const node2 = ($.trim($('#endNodeName').val()));
      searchNames = [node1,node2];
    }
    // 获取实例节点
		let nodes1 = nodes.filter(item => item.labels.indexOf('InstanceNode')>=0);
    // 获取关系名称节点
		let nodes2 = nodes.filter(item => item.labels.indexOf('Relation')>=0);
    let forceConfig = isCenterSearch ? [130, 50, -1600] : [180, 150, -500];
    // 画布的宽高
    let width = $('#knowledgeGraph').width();
    let height = $('#knowledgeGraph').height();
    let simulation = d3.forceSimulation(nodes)
      .force("link", d3.forceLink(links).id(d => d.id).distance(forceConfig[0]))
      .force("center", d3.forceCenter(width / 2, height / 2))
      .force("charge", d3.forceManyBody().strength(forceConfig[2]))
      .force("collision", d3.forceCollide(forceConfig[1]))
      .force("x", d3.forceX())
      .force("y", d3.forceY());
    let relMap_g = d3.select('g.relMap_g');
    // 关系路径检索才需要绘制箭头
    if(!isCenterSearch){
      d3.select("defs.arrows").selectAll(".linkMarker")
        .data(links)
        .enter()
        .append("marker")
        .attr("class", "linkMarker")
        .attr('id', function (d) {
          return "marker-" + d.properties.uuid;
        })
        .attr("markerWidth", 20)
        .attr("markerHeight", 20)
        .attr("refX", 70)
        .attr("refY", 6)
        .attr("orient", "auto")
        .attr("markerUnits", "userSpaceOnUse")
        .append("path")
        .attr("d", "M 0 0 12 6 0 12Z")
        .attr("fill", '#999999');
    }
    // 绘制节点图像
    // 绘制图片的容器
    let imgPatterns = d3.select("defs.avatars").selectAll(".nodeImg")
      .data(nodes1)
      .enter()
      .append("pattern")
      .attr("class", "nodeImg")
      .attr("id", function(d, index) {
        return 'avatar' + d.properties.nodeId;
      })
      // 两个取值userSpaceOnUse  objectBoundingBox
      .attr('patternUnits', 'objectBoundingBox')
      // <pattern>，x、y值的改变决定图案的位置，宽度、高度默认为pattern图案占填充图形的百分比。
      .attr("x", "10")
      .attr("y", "10")
      .attr("width", "5")
      .attr("height", "5");
    // 插入新节点的圆形背景
    imgPatterns
      .append("circle")
      .attr("fill", function(d) {
        return "#3F6B81";
      })
      .attr("r", function(d){
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? centerRadius : normalRadius;
      })
      .attr("cx", function(d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? centerRadius : normalRadius;
      })
      .attr("cy", function(d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? centerRadius : normalRadius;
      })
    // 插入新节点的文物图片
    imgPatterns.append("image")
      .attr("class", "image")
      .attr("xlink:href", function(d) {
        let files = d.properties.files;
        if(files && files.length>0){
          let items = files.filter(el => el.fileCategory == 'FILE_TYPE_PICTURE');
          if(items.length>0){
            return pre+'/'+items[0].fileThumbnail;
          }else{
            return Default;
          }
        }else{
          return Default;
        }
      })
      .attr("height", function(d){
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? centerRadius*2 : normalRadius*2;
      })
      .attr("width", function(d){
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? centerRadius*2 : normalRadius*2;
      })
      .attr("preserveAspectRatio", "xMidYMin slice");

    // 每条线是个容器，有线 和一个装文字的容器
    d3Canvas.edges = relMap_g
      .selectAll("g.edge")
      .data(links)
      .enter()
      .append("g")
      .attr("class", function (d) {
        return "edges edge" + d.id;
      })
      .attr("transform", function (d) {
        return getTransform(d.source, d.target, getDis(d.source, d.target))
      });
    // 添加线
    d3Canvas.links = d3Canvas.edges.append("path")
      .attr("class", "links")
      .attr('stroke-dasharray', function (d) {
        if (d.type == 'attribute' || d.type == 'Tag') {
          return '2 4'
        }
      })
      .attr("d", d => {
				return "M" + 0 + "," + 0 + " L" + getDis(d.source, d.target) + ",0";
      })
      .style("marker-end", function (d) {
        return "url(#marker-" + d.properties.uuid + ")";
      })
      .attr('stroke', (d) => {
        return '#999999';
      })
      .attr("stroke-width", function (d) {
        return '1';
      });
    // 关系路径检索时才需要绘制关系名称
    if(!isCenterSearch){
      // 添加关系文字的容器
      let rect_g = d3Canvas.edges.append("g")
        .attr("class", "rect_g")
        .on("click", function (d) {
          // console.log(d);
        });
      // 添加rect
      d3Canvas.rects = rect_g.append("rect")
        .attr("y", -10)
        .attr("height", 20)
        .attr("id", function (d) {
          return 'linkRect-' + d.properties.uuid
        })
        .attr("fill", function (d) {
          return '#838383'
        })
        .attr("rx", '10')
        .attr("ry", '15')

      // 关系名称  坐标（x,y）代表 文本的左下角的点
      d3Canvas.texts = rect_g.append("text")
        .attr("text-anchor", "middle") // <text>文本中轴对齐方式居中  start | middle | end
        .style("font-size", function (d) {
          return 12
        })
        .attr("id", function (d) {
          return 'linkText-' + d.properties.uuid
        })
        .text(d => {
          return d.properties.relationshipName
        })
        .attr("fill", function (d) {
          return '#f2f2f2'
        })
        .attr("y", function (d) {
          return 5
        })
        .attr("x", function (d) {
          // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
          let bbox = d3.select(this).node().getBBox();
          let width = bbox.width;
          $(this).prev('rect').attr('width', width + 10);
          // 7.3.2 更新 text 的位置
          return getDis(d.source, d.target) / 2
        })
        .attr("transform", function (d) {
          // 7.3.3 更新文本反正
          if (d.target.x < d.source.x) {
            let x = getDis(d.source, d.target) / 2;
            return 'rotate(180 ' + x + ' ' + 0 + ')';
          } else {
            return 'rotate(0)';
          }
        });
    }
    // 绘制实例节点的圆形
    d3Canvas.circles = relMap_g.selectAll("circle.circles")
      .data(nodes1)
      .enter()
      .append("circle")
      .attr("class", function (d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? 'circles centerNode circle'+d.properties.nodeId : 'circles circle'+d.properties.nodeId;
      })
      .style("cursor", "pointer")
			.attr("fill", function(d) {
				return("url(#avatar" + d.properties.nodeId + ")");
			})
      .attr("stroke", function (d) {
        return '#9A7B79';
      })
      .attr("stroke-width", function (d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? 10 : 0; 
      })
      .attr("r", function (d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? centerRadius : normalRadius;
      })
      .attr("cx", function (d) {
        return d.x;
      })
      .attr("cy", function (d) {
        return d.y;
      })
      // 鼠标单击
      .on('click', function (event, d) {
        if(!isSearch){
          return;
        }
        // 移除上一次单击选中的节点高亮样式
        if(selectedNodeId && d3.select('.circle'+selectedNodeId)){
          const classname = d3.select('.circle'+selectedNodeId).attr('class').replace(' active','');
          d3.select('.circle'+selectedNodeId).attr('class',classname)
        }
        // 给这一次单击选中的节点添加高亮样式
        const classname1 = d3.select('.circle'+d.properties.nodeId).attr('class');
        d3.select('.circle'+d.properties.nodeId).attr('class',classname1+' active');
        selectedNodeId = d.properties.nodeId;
        // 查看详情
        queryInstanceDetails({
          instanceId: d.properties.nodeId
        }).then(res => {
          if (res) {
            setTitle(res.instanceName);
            setDesc(res)
            setDshow(true);
          } else {
            setDshow(false);
          }
        });
      })
      .on('mouseenter', function (event, d) {
        const nodeName = d.properties.nodeName;
        d3.select('.circleText'+d.properties.nodeId).text(nodeName);
      })
      .on('mouseleave', function (event, d) {
        const nodeName = d.properties.nodeName.length>5 ? d.properties.nodeName.slice(0,5)+'...' :  d.properties.nodeName;
        d3.select('.circleText'+d.properties.nodeId).text(nodeName);
      })
      .call(drag(simulation));
    // 绘制实例节点的文字
    d3Canvas.circleTexts = relMap_g.selectAll("text.circleTexts")
      .data(nodes1)
      .enter()
      .append("text")
      .attr("class", function (d) {
        return 'circleTexts circleText'+d.properties.nodeId;
      })
      .attr('font-size', 13)
      .style('fill', function (d) {
        return "#333333";
      })
      .attr("dominant-baseline", "middle")
      .attr("text-anchor", "middle")
      .text(function (d) {
        return (d.properties.nodeName.length>5 ? d.properties.nodeName.slice(0,5)+'...' :  d.properties.nodeName);
      })
      .attr("x", function (d) {
        return d.x;
      })
      .attr("y", function (d) {
        return searchNames.indexOf(d.properties.nodeName)>=0 ? d.y+centerRadius+20 : d.y+normalRadius+18;
      })
      .on('mouseenter', function (event, d) {
        const nodeName = d.properties.nodeName;
        d3.select('.circleText'+d.properties.nodeId).text(nodeName);
      })
      .on('mouseleave', function (event, d) {
        const nodeName = d.properties.nodeName.length>5 ? d.properties.nodeName.slice(0,5)+'...' :  d.properties.nodeName;
        d3.select('.circleText'+d.properties.nodeId).text(nodeName);
      });
    // 中心节点检索才需要绘制关系节点
    if(isCenterSearch){
      let relationNodes = relMap_g.selectAll('g.relationNodes')
        .data(nodes2)
        .enter()
        .append("g")
        .style("cursor", "pointer")
        .attr("class", "relationNodes")
        .call(drag(simulation));
      // 绘制关系节点的矩形
      d3Canvas.relationRects = relationNodes
        .append("rect")
        .attr("class", function (d) {
          return 'relationRects';
        })
        .attr("fill", '#838383')
        .attr("height", 24)
        .attr("y", function(d) {
          return d.y-13;
        })
        .attr("rx", 15)
        .attr("ry", 15);
      // 绘制关系节点的文字
      d3Canvas.relationRectTexts = relationNodes
        .append("text")
        .attr('class', 'relationRectTexts')
        .attr('font-size', 13)
        .style('fill', function (d) {
          return "#f2f2f2";
        })
        .attr("dominant-baseline", "middle")
        .attr("text-anchor", "middle")
        .text(function (d) {
          return d.properties.nodeName;
        })
        .attr("x", function(d) {
          // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
          let textArea = $(this)[0].getBoundingClientRect();
          let width = textArea.width;
          $(this).prev('rect').attr('width', width + 30);
          $(this).prev('rect').attr('x', d.x - (width + 30)/2);
          // 7.3.2 更新 text 的位置
          return d.x
        })
        .attr("y", function(d) {
          return d.y;
        });
      }
    // 图谱显示位置
    simulation.on("tick", () => {
      updateMapLocation(searchNames,isCenterSearch);
    });
  }
  // 更新图谱位置方法
  const updateMapLocation = (searchNames,isCenterSearch) => {
    // 足够稳定时，才渲染一次
    d3Canvas.circles
      .attr("cx", function (d) {
        return d.x;
      })
      .attr("cy", function (d) {
        return d.y;
      })
    d3Canvas.circleTexts
      .attr("x", function (d) {
        return d.x;
      })
      .attr("y", function (d) {
        return searchNames.indexOf(d.properties.nodeName)>=0 ? d.y+centerRadius+20 : d.y+normalRadius+18;
      })
    // 中心节点检索时才需要考虑关系节点
    if(isCenterSearch){
			d3Canvas.relationRects
				.attr("y", function(d) {
					return d.y-13;
				});
      d3Canvas.relationRectTexts
        .attr("x", function(d) {
          // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
          let textArea = $(this)[0].getBoundingClientRect();
          let width = textArea.width;
          $(this).prev('rect').attr('width', width + 20);
          $(this).prev('rect').attr('x', d.x - (width + 20)/2);
          // 7.3.2 更新 text 的位置
          return d.x
        })
        .attr("y", function(d) {
          return d.y;
        });	
    }
    // 关系路径检索时才需要考虑连线上的关系名称容器
    else{
      d3Canvas.rects
        .attr("x", function (d) {
          return getDis(d.source, d.target) / 2 - $(this).attr('width') / 2
        }) // x 坐标为两点中心距离减去自身长度一半
      d3Canvas.texts
        .attr("x", function (d) {
          // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
          let bbox = d3.select(this).node().getBBox();
          let width = bbox.width;
          $(this).prev('rect').attr('width', width + 10);
          // 7.3.2 更新 text 的位置
          return getDis(d.source, d.target) / 2
        })
        .attr("transform", function (d) {
          // 7.3.3 更新文本反正
          if (d.target.x < d.source.x) {
            let x = getDis(d.source, d.target) / 2;
            return 'rotate(180 ' + x + ' ' + 0 + ')';
          } else {
            return 'rotate(0)';
          }
        });
    }
    d3Canvas.links
      .attr("d", d => {
				return "M" + 0 + "," + 0 + " L" + getDis(d.source, d.target) + ",0";
      })
    d3Canvas.edges
      .attr("transform", function (d) {
        return getTransform(d.source, d.target, getDis(d.source, d.target))
      });
  }

  // 图谱缩放相关函数
  const zoomed = (event) => {
    d3.select(".svgBox").attr("transform", "translate(" + event.transform.x + "," + event.transform.y +") scale(" + event.transform.k + "," + event.transform.k + ")");
  }

  // 求元素移动到目标位置所需要的 transform 属性值
  const getTransform = (source, target, _dis) => {
    let r;
    if (target.x > source.x) {
      if (target.y > source.y) {
        r = Math.asin((target.y - source.y) / _dis)
      } else {
        r = Math.asin((source.y - target.y) / _dis);
        r = -r;
      }
    } else {
      if (target.y > source.y) {
        r = Math.asin((target.y - source.y) / _dis);
        r = Math.PI - r;
      } else {
        r = Math.asin((source.y - target.y) / _dis);
        r -= Math.PI;
      }
    }
    r = r * (180 / Math.PI);
    return "translate(" + source.x + "," + source.y + ")rotate(" + r + ")";
  }

  // 求两点间的距离
  const getDis = (s, t) => {
    return Math.sqrt((s.x - t.x) * (s.x - t.x) + (s.y - t.y) * (s.y - t.y));
  }

  // 图谱拖拽相关函数
  const drag = (simulation) => {
    function dragstarted(d) {
      if (!d.active) simulation.alphaTarget(0.3).restart();
      d.subject.fx = d.subject.x;
      d.subject.fy = d.subject.y;
      // console.log(d)
    }

    function dragged(d) {
      d.subject.fx = d.x;
      d.subject.fy = d.y;
      // console.log(d)
    }

    function dragended(d) {
      if (!d.active) simulation.alphaTarget(0);
      d.subject.fx = null;
      d.subject.fy = null;
      d.fixed = false;
    }
    return d3.drag()
      .on("start", dragstarted)
      .on("drag", dragged)
      .on("end", dragended);
  }

  // 清空图谱数据
  const emptyMapDatas = () => {
    d3.select('.arrows').selectAll('marker').remove();
    d3.select('.avatars').selectAll('pattern').remove();
    d3.select('.relMap_g').selectAll('g').remove();
    d3.select('.relMap_g').selectAll('circle').remove();
    d3.select('.relMap_g').selectAll('text').remove();
  }

  // 选中或取消选中某条关系路径
  const cancelOrSelectPath = (isSelect,data) => {
    // 当前为取消选中操作
    if(!isSelect){
      d3.selectAll('.circles').attr('opacity',1);
      d3.selectAll('.circleTexts').attr('opacity',1);
      d3.selectAll('.edges').attr('opacity',1);
    }else{
      d3.selectAll('.circles').attr('opacity',0.1);
      d3.selectAll('.circleTexts').attr('opacity',0.1);
      d3.selectAll('.edges').attr('opacity',0.1);
      data.nodes.forEach(el => {
        d3.selectAll('.circle'+el.properties.nodeId).attr('opacity',1);
        d3.selectAll('.circleText'+el.properties.nodeId).attr('opacity',1);
      })
      data.relationships.forEach(el => {
        d3.selectAll('.edge'+el.id).attr('opacity',1);
      })
    }
  }

  // 根据概念筛选节点
  const filterNodesByConcept = (i) => {
    let target = $('.legend ul li').eq(i);
    if(target.hasClass('active')){
      target.removeClass('active');
    }else{
      target.addClass('active');
    }
    // 清除力导向图
    emptyMapDatas();
    let items = $('.legend ul li.active');
    // 未选择任何概念
    if(items.length == 0){
      // 未选中任何概念时，也需要保留中心节点
      const nodes = [renderData.nodes[0]];
      const links = [];
      // 重新绘制力导向图
      showMap(nodes, links,true);
    }
    // 全选
    else if(items.length == conceptConfig.length){
      const nodes = renderData.nodes;
      const links = renderData.links;
      // 重新绘制力导向图
      showMap(nodes, links,true);
    }
    // 选中部分概念
    else{
      let concepts =[];
      for(let j=0;j<items.length;j++){
        concepts.push(items.eq(j).attr('id'));
      }
      console.log(concepts)
      // 获取选中的概念节点
      const centerNode = renderData.nodes[0];
      let nodes = renderData.nodes.filter(el => concepts.indexOf(el.rootConceptId)>=0);
      if(nodes.filter(el => el.properties.nodeId === centerNode.properties.nodeId).length === 0){
        nodes.unshift(centerNode);
      }
      // 获取与选中的概念节点相关联的关系（连线）
      let links = [];
      let links1 = [];
      renderData.links.forEach(el => {
        const len1 = nodes.filter(el1 => el1.id == el.startNodeId || el1.id == el.endNodeId).length;
        if(len1>0){
          links1.push(el)
        }
      });
      // 获取关系节点
      let relationNodes = renderData.nodes.filter(el => el.properties.conceptName == '关系');
      let removeNodeIds = [];
      relationNodes.forEach(el => {
        const len1 = links1.filter(el1 => (el1.startNodeId == el.id && el1.endNodeId == centerNode.id) || (el1.endNodeId == el.id && el1.startNodeId == centerNode.id)).length;
        const len2 = links1.filter(el1 => (el1.startNodeId == el.id && el1.endNodeId != centerNode.id) || (el1.endNodeId == el.id && el1.startNodeId != centerNode.id)).length;
        if(len1>0 && len2>0){
          nodes.push(el)
        }else{
          removeNodeIds.push(el.id);
        }
      })
      links = links1.filter(el => removeNodeIds.indexOf(el.startNodeId) == -1 && removeNodeIds.indexOf(el.endNodeId) == -1);
      // 重新绘制力导向图
      console.log(nodes,links)
      showMap(nodes, links,true);
    }
  }

  // 相关推荐 获取下一组方法
  const nextGroup = (i) => {
    let res = JSON.parse(JSON.stringify(showdata));
    let current = showdata[i].start + 4;
    if(current <= showdata[i].datas.length - 1){
      res[i].start = current;
    }else{
      res[i].start = 0;
      current = 0;
    }
    let currentDatas = showdata[i].datas.slice(current,current+4);
    res[i].show = currentDatas;
    setShowData(res);
  }

  return (
    <div className={cls("relation",{isNotSearch:!isSearch})}>
      <div className="knowledgeGraph" id="knowledgeGraph" style={{'opacity': opacity}}/>
      {loading && <Loading />}
      <div className={cls("dialog", {move: dshow},{hide:!isSearch})}>
        <div className="close" onClick={() => {setDshow(false)}} ><i className="iconfont icon-guanbi" /></div>
        <div className="inner">
        {title && <p className="title">{title}</p>}
        {/* <div className="desc">{desc}</div> */}
        <div className="desc">
          {desc?.attrFields?.map((item, index) => {
            let name;
            desc?.attrTriples.forEach(i => {
              if (i.englishCode === item) {
                name = i.relationshipName;
              }
            })
            const val = desc?.properties[item] && htmltoStr(desc?.properties[item]);
            return (
              name && val && <p className="desc-item" key={index}><span>{name}</span>{val}</p>
            )
          })}
          {desc?.properties?.description && <p className="cont">{htmltoStr(desc?.properties?.description)}</p>}
        </div>
        </div>
      </div>
      <div className={cls('lt', {active: !searchfold},{hide:!isSearch},{pathSearch: tab === 2})}>
        <div className="tab">
          <div
            onClick={() => {
              // setVal1('');
              // setTemp('');
              closeDrop();
              setTab(1);
              // 由关系路径检索切换至中心节点检索时，默认将起始节点设置为中心节点，进行一次查询
              const nodeName = $('#startNodeName').val();
              if(nodeName){
                setTemp(nodeName)
                setName(nodeName)
                $('#centerNodeName').val(nodeName)
              }
            }}
            className={cls("tab1", {active: tab === 1})}
          >中心节点检索<i className='iconfont icon-zhishijiansuo' /></div>
          <div
            onClick={() => {
              // setVal1(temp);
              closeDrop();
              setTab(2);
              // 由中心节点检索切换至关系路径检索时，默认将中心节点设置为起始节点，清除终止节点，清除关系路径列表
              const nodeName = $('#centerNodeName').val();
              if(nodeName){
                setVal1(nodeName)
                $('#startNodeName').val(nodeName)
              }else{
                setVal1('');
                $('#startNodeName').val('');
              }
              setVal2('');
              $('#endNodeName').val('');
              setList([]);
            }}
            className={cls("tab2", {active: tab === 2})}
          >关系路径检索<i className='iconfont icon-guanxijiansuo' /></div>
        </div>
        {tab === 1 && <><div className={cls('input-box', {active: autolist && showauto})}>
          <input type="text" id="centerNodeName" onChange={(e) => {setTemp(e.target.value); getAutolist(e.target.value)}} onKeyDown={handleKeyDown} placeholder="输入中心节点名称或点击下方热门推荐" defaultValue={name || centersearch}/>
          <div
            className="delete-btn"
            onClick={() => {
              $('#centerNodeName').val('');
              setTemp('');
            }}
          />
          <div className="btn" onClick={() => {
            setName(temp)
            setShowauto(false)
          }} />
        </div>
        {autolist && <ul className={cls('autolistul', { 'hide': !temp || !showauto })}>
          {autolist?.length > 0 ? autolist.map((item, index) => {
            return (
              <li className='autolist' key={index} onClick={(e) => {
                setTemp(item)
                setShowauto(false)
                setName(item)
                $('#centerNodeName').val(item)
              }}>
                {item}
              </li>
            )
          }) : (
            <p className='empty-re'>暂无相关信息，建议您更换节点或尝试热点推荐</p>
          )}
        </ul>}
        </>}
        {/* 程颐  嵩阳书院  万松行秀  雪庭福裕 */}
        <Input2 tab={tab} autolist1={autolist1} autolist2={autolist2} showauto1={showauto1} showauto2={showauto2} setVal1={setVal1} setVal2={setVal2} handleSearch={handleSearch} setShowauto2={setShowauto2} setShowauto1={setShowauto1} getAutolist2={getAutolist2} getAutolist1={getAutolist1} endsearch={endsearch} exchange={exchange} startsearch={startsearch} setFocus={setFocus} val1={val1} val2={val2} />
        <div className="input-listbox">
          {autolist1 && <ul className={cls('autolistul autolistul1', { 'hide': !val1 || !showauto1 })}>
            {autolist1?.length > 0 ? autolist1.map((item, index) => {
              return (
                <li className='autolist' key={index} onClick={() => {
                  setVal1(item);
                  setShowauto1(false);
                  $('.input2 .val1').val(item);
                  if(val2) {
                    linkSearch(item, val2);
                  }
                }}>
                  {item}
                </li>
              )
            }) :  (
              <p className='empty-re'>暂无相关信息，建议您更换节点或尝试热点推荐</p>
            )}
          </ul>}
          {autolist2 && <ul className={cls('autolistul autolistul2', { 'hide': !val2 || !showauto2 })}>
            {autolist2?.length > 0 ? autolist2?.map((item, index) => {
              return (
                <li className='autolist' key={index} onClick={() => {
                  setVal2(item);
                  setShowauto2(false);
                  $('.input2 .val2').val(item);
                  if(val1) {
                    linkSearch(val1, item);
                  }
                }}>
                  {item}
                </li>
              )
            }) :  (
              <p className='empty-re'>暂无相关信息，建议您更换节点或尝试热点推荐</p>
            )}
          </ul>}
        </div>
        <SameAnn tab={tab} isSame={isSame}/>
        <Empty tab={tab} list={list} />
        <div className="cut-line" />
        <Pathlist list={list} tab={tab} showdata={showdata} nextGroup={nextGroup} handleChoose={handleChoose} cancelOrSelectPath={cancelOrSelectPath} startNode={startNode} endNode={endNode} startNodeId={startNodeId}/>
        <div className={cls('fold', {active: !searchfold})} onClick={() => {
          setSearchfold(!searchfold);
        }}>
          <i className="iconfont icon-huidingbu-01" />
        </div>
      </div>
      <div className={cls("legend", {hide: !isCenter || !isSearch})}>
        <ul>
          {conceptConfig?.length > 0 && conceptConfig?.map((item, index) => {
                // console.log(item)
                return (
                  <li className={cls('active',item.conceptCode)} key={index} id={item.conceptId} onClick={(e) => {
                    filterNodesByConcept(index);
                  }}>
                    <div className="circle"/>
                    <span className="name">{item.conceptName}</span>
                  </li>
                )
              })}
        </ul>
      </div>
    </div>
  )
}
const Empty = ({tab, list}) => {
  if(tab === 2 && list?.length === 0) {
    return (
      <div className="pathempty">
        <div className="empty-icon" />
        <p>暂未找到关系路径，建议您更换节点或尝试热点推荐</p>
      </div>
    )
  } else {
    return null;
  }
}
const Recommand = ({showdata, nextGroup,handleChoose}) => {
  return (
    <div className="hot-recommand scrollContainer">
      {
        showdata?.map((el,i) => {
          return (
            <div key={i}>
              <p className="title">
                {el?.title?.replace('推荐','热点')}
                <span className='nextBtn' onClick={()=>{nextGroup(i);}}>下一组</span>
              </p>
              <ul className="list">
                {el?.show.map((item, index) => {
                  return (
                    <li
                      key={index}
                      onClick={() => {
                        handleChoose(item.title)
                      }}
                    >
                      <div className="img">
                        {item.showImage ? <img src={pre+item.showImage} alt="" /> : <img src={Default} alt="" />}
                      </div>
                      <p className="name">{item.title}</p>
                    </li>
                  )
                })}
              </ul>
            </div>
          )
        })
      }
      
      {/* <p className="title">
        {showdata?.relic.title}
        <span className='nextBtn'>下一组</span>
      </p>
      <ul className="list">
        {showdata?.relic.datas.map((item, index) => {
          return (
            <li
              key={index}
              onClick={() => {
                handleChoose(item.name)
              }}
            >
              <div className="img">
                {item.filePath ? <Picture source={item.filePath} /> : <img src={Default} alt="" />}
              </div>
              <p className="name">{item.name}</p>
            </li>
          )
        })}
      </ul>
      <p className="title">
        {showdata?.person.title}
        <span className='nextBtn'>下一组</span>
      </p>
      <ul className="list">
        {showdata?.relic.datas.map((item, index) => {
          return (
            <li
              key={index}
              onClick={() => {
                handleChoose(item.name)
              }}
            >
              <div className="img">
                {item.filePath ? <Picture source={item.filePath} /> : <img src={Default} alt="" />}
              </div>
              <p className="name">{item.name}</p>
            </li>
          )
        })}
      </ul> */}
    </div>
  )
}
const Input2 = ({tab, autolist1, autolist2, showauto1, showauto2, setVal1, setVal2, handleSearch, setShowauto2, setShowauto1, getAutolist2, getAutolist1, endsearch, exchange, startsearch, setFocus, val1, val2}) => {
  const deleteInput = (val, setval) => {
    $(`.input2 .${val}`).val('');
    setval('');
  }
  return tab === 2 ? (<div className="input2">
    <div className="input2-box">
    <input type="text" id="startNodeName" className={cls("val1", {active: autolist1 && showauto1})} onChange={(e) => {setVal1(e.target.value); getAutolist1(e.target.value)}}  onKeyDown={handleSearch} onFocus={() => {setShowauto2(false); setFocus(1);}} defaultValue={val1 || startsearch} placeholder="输入起点节点名称或点击下方热点推荐" />
    <div className="delete-btn" onClick={() => {deleteInput('val1', setVal1)}} />
    </div>
    {/* <span className="change" /> */}
    <i className='iconfont icon-xianghujiaohuan' onClick={exchange} />
    <div className="input2-box">
    <input type="text" id="endNodeName" className={cls("val2", {active: autolist2 && showauto2})} onChange={(e) => {setVal2(e.target.value);getAutolist2(e.target.value)}} onKeyDown={handleSearch} onFocus={() => {setShowauto1(false); setFocus(2);}} defaultValue={val2 || endsearch} placeholder="输入终点节点名称或点击下方热点推荐" />
    <div className="delete-btn" onClick={() => {deleteInput('val2', setVal2)}} />
    </div>
    {/* <div className="btn" onClick={() => {
      linkSearch();
    }}/> */}
  </div>
  ) : null;
}
const Pathlist = ({list, tab, showdata,nextGroup, handleChoose, cancelOrSelectPath,startNode,endNode,startNodeId}) => {
  const [active, setActive] = useState();
  // 关系路径数据发生变化时清除路径选中效果
  useEffect(() => {
    setActive('')
  }, [list])
  return tab === 2 && list?.length > 0 ?
    (
      <>
      <div className="result scrollContainer">
        <p className="title">关系路径列表</p>
        <ul>
          {list?.map((item,index) => {
            const arr = item?.nodes?.map(i => {
              return i.properties.nodeName
            })
            const str = arr.join('、');
            return(
              <li
                key={index}
                className={cls({active: index === active})}
                onClick={() => {
                  if(index === active) {
                    setActive('')
                    cancelOrSelectPath(false,{});
                  } else {
                    setActive(index)
                    cancelOrSelectPath(true,item);
                  }
                }}>
                <p>关系深度：{item.relationships.length}</p>
                <p>途径条目：{str}</p>
              </li>
            )
          })}
        </ul>
      </div>
      <Star operationType = '3' instanceId={startNodeId} startNodeName={startNode} endNodeName={endNode} active={active} list={list}/>
      </>
    ) : (
      <Recommand showdata={showdata} nextGroup={nextGroup} handleChoose={handleChoose} />
    )
}

const SameAnn = ({isSame, tab}) => {
  return isSame && tab === 2 ? (
    <div className="annouce">
      请为起始节点和终点节点输入不同的关键词
    </div>
  ) : null
}
export default Relation;
